export default function Logo({ dark = false }) {
    return (
        <span className="flex items-center gap-2.5" data-testid="brand-logo">
            <svg viewBox="0 0 48 48" className="h-10 w-10 shrink-0" aria-hidden="true">
                <circle cx="24" cy="24" r="23" fill={dark ? "#FAF7F2" : "#0F281E"} />
                <circle cx="24" cy="24" r="20.5" fill="none" stroke="#D4A373" strokeWidth="1" />
                <text x="24" y="33" textAnchor="middle" fontFamily="Georgia, 'Times New Roman', serif" fontStyle="italic" fontSize="26" fill={dark ? "#0F281E" : "#D4A373"}>
                    D
                </text>
                <path d="M15 13.5 Q24 8 33 13.5" fill="none" stroke={dark ? "#0F281E" : "#D4A373"} strokeWidth="1.2" strokeLinecap="round" />
                <path d="M18 37 Q24 40 30 37" fill="none" stroke={dark ? "#0F281E" : "#D4A373"} strokeWidth="1" strokeLinecap="round" />
            </svg>
            <span className="leading-none">
                <span className={`block font-serif text-lg font-semibold tracking-tight ${dark ? "text-forest-deep" : "text-white"}`}>
                    Destino
                </span>
                <span className={`block font-accent text-[10px] font-medium uppercase tracking-[0.34em] ${dark ? "text-forest-emerald" : "text-gold"}`}>
                    Resorts
                </span>
            </span>
        </span>
    );
}
